import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AttachInvestigationDocumentModal from 'Components/Modals/AttachInvestigationDocumentModal';
import FileRow from './FileRow';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    paddingRight: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  files: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  headerRow: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  uploadDocument: {
    display: 'flex',
    flexFlow: 'row',
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  fileRows: {
    overflow: 'scroll',
    flexBasis: '18em',
  },
});

const View = ({
  classes,
  documents,
  investigationURL,
  onClickShowAttachFileModal,
  onCloseAttachFileModal,
  showAttachFileModal,
}) => {
  return (
    <Box className={classes.root}>
      {showAttachFileModal && (
        <AttachInvestigationDocumentModal
          investigationURL={investigationURL}
          onClose={onCloseAttachFileModal}
        />
      )}
      <Box debugColor="coral" className={classes.headerRow}>
        <Typography
          className={classes.files}
          color="primary"
          variant="h3"
        >
          Files
        </Typography>
        <Box debugColor="gold" className={classes.uploadDocument}>
          <Button
            startIcon={<AttachFileIcon />}
            onClick={onClickShowAttachFileModal}
          >
            Upload Document
          </Button>
        </Box>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.fileRows}>
        {documents.map(document => (
          <Box>
            <FileRow
              fileURL={document.fileURL}
              fileName={document.fileName}
              createdAt={document.createdAt}
              createdBy={document.createdBy}
              resource={document.resource}
              onRemoveFile={onCloseAttachFileModal}
            />
            <Divider className={classes.divider} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  investigationURL: PropTypes.string.isRequired,
  onClickShowAttachFileModal: PropTypes.func.isRequired,
  onCloseAttachFileModal: PropTypes.func.isRequired,
  showAttachFileModal: PropTypes.bool.isRequired,
};

export default withStyles(styles)(View);
